const reasons = {
    'Red Card': 'Sancionado por tarjeta roja',
    'Yellow Cards': 'Acumulación de amarillas',
    Injury: 'Lesionado',
    'Hamstring Injury': 'Lesión en el isquiotibial',
    'Knee Injury': 'Lesión de rodilla',
    'Muscle Injury': 'Lesión muscular',
    'Ankle Injury': 'Lesión de tobillo',
    'Thigh Injury': 'Lesión en el muslo',
    Inactive: 'Inactivo',
    'Calf Injury': 'Lesión en la pantorrilla',
    'Coachs decision': 'Decisión del entrenador',
    'Shoulder Injury': 'Lesión en el hombro',
    'Groin Injury': 'Lesión en la ingle',
    'Achilles Tendon Injury': 'Lesión en el tendón de Aquiles',
    Illness: 'Enfermedad',
    'Ribs Injury': 'Lesión en las costillas',
    'Lacking Match Fitness': 'Falta de forma física',
    Rest: 'Descanso',
    'Foot Injury': 'Lesión en el pie',
    'Heel Injury': 'Lesión en el talón',
    Knock: 'Golpe',
    'Broken nose': 'Nariz rota',
    'Back Injury': 'Lesión en la espalda',
    'Broken jawbone': 'Mandíbula rota',
    Suspended: 'Suspendido',
    'Loan agreement': 'Cesión / Préstamo',
    'Wrist Injury': 'Lesión en la muñeca',
    'Hand Injury': 'Lesión en la mano',
    'Leg Injury': 'Lesión en la pierna',
    'Personal Reasons': 'Razones personales',
    Concussion: 'Conmoción cerebral',
    'Head Injury': 'Lesión en la cabeza',
    'Health problems': 'Problemas de salud',
    Contusion: 'Contusión',
    'Stomach Disorder': 'Trastorno estomacal',
    'Face Injury': 'Lesión en la cara',
    'Toe Injury': 'Lesión en el dedo del pie',
    'Abdominal strain': 'Distensión abdominal',
    'Hip Injury': 'Lesión en la cadera',
};

export const missingFixtureReasons = (reason) => {
    return reasons[reason] || reason;
};
